import { Config } from '#lib/constants/config.js';

export const HENI_ORGANIZATION_ID = `${Config.Domain}#publisher`;

// Mirrors the publisher block in the news article JSON-LD
// (NewsArticleJsonLdHead/utils/getJsonLdScriptTag).
export const HENI_SAME_AS = Object.freeze([
	'https://www.facebook.com/HENIGroup',
	'https://twitter.com/heni',
	'https://www.instagram.com/heni',
	'https://uk.linkedin.com/company/heni-group',
	'https://www.youtube.com/c/HENITalks',
]);

export const HENI_ORGANIZATION_REF = Object.freeze({
	'@id': HENI_ORGANIZATION_ID,
});
